import { categoryConstants } from "./constants/categoryContansts";


export const getCategory = (data:any) => ({
  type: categoryConstants.getCategoryRequest,
  payload : data
}); 

const createCategory = (data: any) => ({
  type: categoryConstants.categoryCreateRequest,
  payload: data,
});

const getCategoryParams = (data: any) => ({
  type: categoryConstants.getCategoryParamsRequest,
  payload: data,
});

const deleteCategory = (data: any) => ({
  type: categoryConstants.categoryDeleteRequest,
  payload: data,
});

const toggleCategory = (data: any) => ({
  type: categoryConstants.categoryToggleRequest,
  payload: data,
});

const viewCategory = (data: any) => ({
  type: categoryConstants.categoryViewRequest,
  payload: data,
});

export const categoryActions = {
  getCategory,
  createCategory,
  getCategoryParams,
  toggleCategory,
  deleteCategory,
  viewCategory
};
